export const SPARTAN_SLIDE_PAGINATION_LABELS = {
  ariaLabel: 'Pagination navigation',
  page: (page: number) => `Page ${page}`,
} as const;
